import Swiper from 'swiper/bundle';

const createSlider = (id, tag, params = {}) => {
  if (id > 0) {
    new Swiper(`${tag}_${id} .swiper`, {
      pagination: {
        el: `${tag}_${id} .swiper-pagination`,
        clickable: true,
      },
    
      navigation: {
        nextEl: `${tag}_${id} .swiper-button-next`,
        prevEl: `${tag}_${id} .swiper-button-prev`,
      },

      a11y: {
        enabled: false,
      },

      ...params,
    });
  } else {
    new Swiper(`${tag} .swiper`, {
      pagination: {
        el: `${tag} .swiper-pagination`,
        clickable: true,
      },
    
      navigation: {
        nextEl: `${tag} .swiper-button-next`,
        prevEl: `${tag} .swiper-button-prev`,
      },

      ...params,
    });
  }
}

const changeSlider = (slider, options, id = 0) => {
  const isSwiper = slider?.querySelector(".swiper");
  const sliderSlides = isSwiper?.querySelectorAll(".swiper-slide");
  const sliderBtnPrev = slider?.querySelector(".swiper-button-prev");
  const sliderBtnNext = slider?.querySelector(".swiper-button-next");

  if (sliderSlides?.length > 3 && slider?.classList.contains('main-slider--three-slide')) {
    sliderBtnPrev?.classList.add('active');
    sliderBtnNext?.classList.add('active');
  } else if (sliderSlides?.length > 4 && slider?.classList.contains('main-slider--four-resizible-slide')) {
    sliderBtnPrev?.classList.add('active');
    sliderBtnNext?.classList.add('active');
  } else if (sliderSlides?.length > 1 && slider?.classList.contains('ligthbox-slider')) {
    sliderBtnPrev?.classList.add('active');
    sliderBtnNext?.classList.add('active');
  }

  if(isSwiper) {
    createSlider(id, options.tag, options.params);
  }
}

export const staticSwipers = () => {
  const elementsSlider = [
    {
      tag: ".main-slider--three-slide",
      params: {
        breakpoints: {
          320: {
            slidesPerView: 1,
            spaceBetween: 20
          },
          576: {
            slidesPerView: 2,
            spaceBetween: 20
          },
          900: {
            slidesPerView: 3,
            spaceBetween: 24,
          }
        }
      },
    },
    {
      tag: ".main-slider--one-slide",
      params: {
        slidesPerView: 1,
        spaceBetween: 20,
      },
    },
    {
      tag: ".ligthbox-slider",
      params: {
        pagination: {
          el: '.swiper-pagination',
          type: 'fraction',
        },
      },
    },
  ];

  for(let i = 0; i < elementsSlider.length; i++) {
    const isSlider = document?.querySelectorAll(elementsSlider[i].tag);

    if (isSlider.length > 1) {
      isSlider.forEach((item, index) => {
        changeSlider(item, elementsSlider[i], index + 1);
      });
    } else {
      changeSlider(isSlider[0], elementsSlider[i]);
    }
  }
}

export const resizableSwiper = (breakpoint, swiperClass, swiperSettings, callback) => {
  let swiper;

  breakpoint = window.matchMedia(breakpoint);

  const enableSwiper = function(className, settings) {
    swiper = new Swiper(className, settings);

    if (callback) {
      callback(swiper);
    }

    const sliderSwiper = document.querySelector(swiperClass);
    const sliderSlides = sliderSwiper?.querySelectorAll('.swiper-slide');
    const sliderBtnPrev = sliderSwiper?.querySelector(".swiper-button-prev");
    const sliderBtnNext = sliderSwiper?.querySelector(".swiper-button-next");

    if (sliderSlides?.length > 4) {
      sliderBtnPrev?.classList.add('active');
      sliderBtnNext?.classList.add('active');
    }
  }

  const checker = function() {
    if (breakpoint.matches) {
      return enableSwiper(`${swiperClass} .swiper`, swiperSettings);
    } else {
      if (swiper !== undefined) swiper.destroy(true, true);
      return;
    }
  };

  breakpoint.addEventListener('change', checker);
  checker();
}